import { RestangularModule, Restangular } from 'ngx-restangular';
import { ModuleWithProviders } from '@angular/core';
import { AuthenticationService } from '../pages/login/authentication.service';
import { AppConfig } from '../app.config';

// Function for settting the default restangular configuration
export function RestangularConfigFactory(RestangularProvider, AuthenticationService) {
    RestangularProvider.setBaseUrl(AppConfig.server);

    RestangularProvider.setRequestInterceptor(function (elem, operation) {
        let token = sessionStorage.getItem("token") || null;
        RestangularProvider.setDefaultHeaders({ 'Authorization': "Bearer " + token });
        return elem;
    })

    RestangularProvider.addErrorInterceptor((response, subject, responseHandler) => {
        console.log("Restangular Error Interceptor called.");
        console.log("Http status : " + response.status);

        if (response.status === 401 || response.statu == 403) {
            AuthenticationService.logout();
            return false;
        }
        return true;
    });

    RestangularProvider.addResponseInterceptor((data, operation, what, url, response) => {
        if (response.headers.get('Authorization') !== 'undefined' && response.headers.get('Authorization') !== null) {
            sessionStorage.setItem("token", response.headers.get('Authorization'));
        }
        return data;
    });

}

// Importing RestangularModule and making default configs for restanglar
export const restangularFactoryHelper: ModuleWithProviders = RestangularModule.forRoot([AuthenticationService], RestangularConfigFactory);




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/services/restangular-factory.helper.ts